import { Component, OnInit, AfterViewInit, Input, HostListener } from '@angular/core';
import { DataQualityAssessmentComponent } from 'src/app/components/data-quality-assessment/data-quality-assessment.component';
import * as d3 from 'd3';

@Component({
  selector: 'app-horizontal-bar-chart',
  templateUrl: './horizontal-bar-chart.component.html',
  styleUrls: ['./horizontal-bar-chart.component.css']
})
export class HorizontalbarchartComponent implements OnInit {
  viewData = [];
  barnumber = 4;
  currentPage = 1;
  totalPage: number;
  chartData: any[] | undefined;
  @Input() GraphData: any;
  NegativeTATChartData: any[] | undefined;
  barChartContainerName: string;
  pieChartContainerName: string;
  XAxis: string;
  displaName: string;
  categoryId: any;

  constructor(public dataQualityService: DataQualityAssessmentComponent) { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.barChartContainerName = "#container0";
    this.pieChartContainerName = "#mlabelpieDQT0";
    this.categoryId = 0;

    // below logic is to exclude Negative Tat from bar chart and prepare data for negative TAT
    this.chartData = this.GraphData.filter(function (item) {
      return item.FieldName !== "Negative TAT";
    });
    this.NegativeTATChartData = this.GraphData.filter(function (item) {
      if (item.FieldName == "Negative TAT") {
        return item.FieldName
      };
    });

    var fieldNames = [];
    if(this.NegativeTATChartData.length > 0){
      Object.keys(this.NegativeTATChartData[0]).forEach(prop => {
        if (prop == 'Percentage') {
          fieldNames.push({ "Negative TAT": this.NegativeTATChartData[0][prop] });
        }
      });  
    }
   
    this.Load100PercBarChart(this.chartData, this.barChartContainerName);
    this.LoadMLPieChartsDQT(this.pieChartContainerName, fieldNames);
  }

  Load100PercBarChart(lineData, chartContainer) {
    let that = this;
    let containerId = chartContainer;
    this.totalPage = Math.ceil(lineData.length / this.barnumber);
    this.viewData = lineData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
    let containerIdwithoutHash = containerId.split('#')[1];
    let divId = '#div_' + containerIdwithoutHash;
    d3.select(chartContainer).html("");
    d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
    d3.select(divId).classed('100Bar', true);
    // this.XAxis = Object.keys(lineData[0])[0];
    this.XAxis = "Missing attributes";
    this.displaName = Object.keys(lineData[0])[1]
    const yscale_bw = 24;
    const rx = yscale_bw / 2, ry = yscale_bw / 2;
    var colors = ['#46BDF0', '#98BB56', '#6FD9DD', '#5589BB', '#68C083', '#2B7BAD', '#E370B3'];
    var lightColors = ['#8dd6f6', '#b9d18d', '#ade9ec', '#8cafd1', '#9ed7af', '#51a1d4', '#f0b0d5'];

    //Finding total number of tickets to calculate the percentage
    var totalTickets = 0;
    lineData.forEach(function (item) {
      totalTickets += item.Percentage;
    });
    if (totalTickets == 0) {
      totalTickets = 1;
    }
    let barWidth = 30;
    let scrollBar = false;
    let divWidth = d3.select(chartContainer).node().offsetWidth / 2 - 50;
    // set the dimensions and margins of the graph
    var svgWidth = d3.select(chartContainer).node().offsetWidth - 50;
    var svgHeight = 350;
    var margin = { top: 20, right: 30, bottom: 50, left: 90 };
    var width = svgWidth - margin.left - margin.right;
    var height = svgHeight - margin.top - margin.bottom;
    var svg: any;
    svg = d3.select(divId).append("svg").attr('id', 'svg_' + containerIdwithoutHash);

    svg
      .attr('width', svgWidth)
      .attr('height', svgHeight);

    svg.append("defs").append("clipPath")
      .attr("id", containerIdwithoutHash + "_clip")
      .append("rect")
      .attr("width", width)
      .attr("height", height);

    //Create group element inside svg element to draw chart
    const chart = svg.append('g')
      .attr("transform",
        "translate(" + margin.left + "," + margin.top + ")"
      );

    var yScale = d3.scaleBand().range([0, height]).domain(this.viewData.map((d) => d.FieldName)).padding(0.36);

    let yAxis = chart.append('g').attr("class", "yaxis").call(d3.axisLeft(yScale)
      .tickSize(9)
      .tickPadding(5))
    //.select('.yaxis path').style('opacity', 1);
    yAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    yAxis
      .select('.domain')
      .style('opacity', 0);
    chart.selectAll('.yaxis .tick text')
      .text(d => {
        if (d.length > 9) {
          d = d.substring(0, 6) + '...';
        }
        return d;
      })
      .append('title')
      .text(d => d);
    var xScale = d3.scaleLinear().range([0, width]).domain([0, 100]);

    let xAxis = chart.append('g')
      .attr('transform', `translate(0, ${height})`)
      .attr("class", "xaxis")
      .call(d3.axisBottom(xScale)
        .tickFormat((d) => d + '%')
        .tickPadding(10)
        .tickSize(-height))
    //.select('.xaxis path').style('opacity', 0);
    xAxis
      .selectAll('line')
      .attr('stroke', '#e6e6e6')
    xAxis
      .select('.domain')
      .style('opacity', 0);

    //Drawing 100% bar chart
    var bargroups = chart
      .append('g')
      .attr("clip-path", "url(#" + containerIdwithoutHash + "_clip)")
      .selectAll()
      .data(this.viewData)
      .enter()
      .append('g');

    var bars = bargroups
      .append('rect')      
      .attr('x', 0)
      .attr('y', (g) => (yScale(g.FieldName) - 2 * rx) + yScale.bandwidth() / 2 + ry)
      .attr('height', yscale_bw)
      .attr('width', width)
      .attr('fill', (d, i) => {
        if (i >= 0) {
          return lightColors[i % colors.length];
        } else {
          return '#A260B7'
        }
      })
      .attr('width', (g) => xScale(g.Percentage))
      .attr("class", "100% bar")
      .attr('fill', (d, i) => {
        let z = 0;
        if (this.currentPage > 1 && i >= 0) {
          z = i + this.barnumber;
        } else { z = i; }
        if (z >= 0) {
          return colors[z % colors.length];
        } else {
          return '#A260B7';
        }
      });

    var roundedCorners = bargroups
      .append('path')
      .attr('class', 'bar')
      .attr("d", d => {
        if (d.Percentage > 0) {
          return `
            M${(xScale((d.Percentage))) - 15},${yScale(d.FieldName) + yScale.bandwidth() / 2}
            a${rx},${ry} 0 1 0 ${rx},${-ry}
            h${yscale_bw - 2 * rx}
            a${rx},${ry} 0 1 0 ${rx},${ry}                 
            h${-(yscale_bw)}Z`
        }
        else {
          return "";
        }
      })
      .attr('fill', (d, i) => {
        let z = 0;
        if (this.currentPage > 1 && i >= 0) {
          z = i + this.barnumber
        } else { z = i; }
        if (z >= 0) {
          return colors[z % colors.length];
        } else {
          return '#A260B7'
        }
      });

    roundedCorners
      .on('mouseover', function (d, i) {
        var i = lineData.indexOf(d);
        d3.select(this).style('fill', function (d) {
          if (lineData.indexOf(d) >= 0) {
            return colors[lineData.indexOf(d) % colors.length]
          }
          else { return "#A260B7" }
        });

        d3.select(this).style('cursor', 'pointer');

        var tooltip = svg
          .append("g")
          .style("cursor", "pointer")
          .attr("class", "tooltip")
          .style("opacity", 1)
        tooltip.append("rect")
          .attr("width", 90)
          .attr('height', 40)
          .style('fill', '#FFFFFF')
          .style('pointer-events', 'none')
          .style('stroke', d3.select(this).style('fill'))
          .style('stroke-width', 2)
          .style('fill-opacity', 0.8);
        var textSvg = tooltip.append("text")
          .attr('x', 7)
          .attr('y', 15)
          .style('pointer-events', 'none')
          .style('fill', '#333333')
          .style('font-size', '12px')
          .style('color', '#333333');
        textSvg.append("tspan")
          .style('font-size', '11px')
          .style('pointer-events', 'none')
          .style("font-family", "Graphik Medium")
          .style('font-weight', 'bold')
          .text(d.FieldName)        

        textSvg.append("tspan")
          .attr('x', 7)
          .attr('dy', 15)
          .style('pointer-events', 'none')
          .style('fill', d3.select(this).style('fill'))
          .html('&#x25cf') 
        textSvg.append("tspan")
          .attr('dx', 0)
          .style('pointer-events', 'none')
          .style('font-size', '11px')
          .style("font-family", "Graphik Medium")
          .style('font-weight', 'bold')
          .text(Object.keys(d)[1] + ": ")
          .style('font-weight', 'bold')
        textSvg.append("tspan")
          .attr('dx', 0)
          .style('pointer-events', 'none')
          .style("font-family", "Graphik Medium")
          .style('font-weight', 'bold')
          .text(d3.format(',')(d.Ticket_Count) + ' (' + (d.Percentage + '%)'));
      })
      .on("mousemove", function (d, i) {        
        d3.select(this).style('fill', function (d) {
          if (lineData.indexOf(d) >= 0) {
            return colors[lineData.indexOf(d) % colors.length]
          }
          else { return "#A260B7" }
        });
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];
        var y = mousePosition[1];
        var text: any;
        text = d3.select(this.closest('svg')).select('.tooltip text');
        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d, i) {
        d3.select(this).style('fill', function (d) {
          if (lineData.indexOf(d) >= 0) {
            return colors[lineData.indexOf(d) % colors.length]
          }
          else { return "#A260B7" }
        });
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)
          .style("opacity", 1);
      })
      .on('click', (d, i) => {
        let z = 0;
        if (this.currentPage > 1 && i >= 0) {
          z = i + this.barnumber
        } else { z = i; }
        this.dataQualityService.GetDataValidityDetails(d, i);        
      });
    bars.on('mouseover', function (d, i) {
      d3.select(this).style('fill', function (d) {
        if (lineData.indexOf(d) >= 0) {
          return colors[lineData.indexOf(d) % colors.length]
        }
        else { return "#A260B7" }
      });
      d3.select(this).style('cursor', 'pointer');
      var tooltip = svg
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "tooltip")
        .style("opacity", 1)
      tooltip.append("rect")
        .attr("width", 90)
        .attr('height', 40)
        .style('fill', '#FFFFFF')
        .style('pointer-events', 'none')
        .style('stroke', d3.select(this).style('fill'))
        .style('stroke-width', 2)
        .style('fill-opacity', 0.8);
      var textSvg = tooltip.append("text")
        .attr('x', 7)
        .attr('y', 15)
        .style('pointer-events', 'none')
        .style('fill', '#333333')
        .style('font-size', '12px')
        .style('color', '#333333');
      textSvg.append("tspan")
        .style('font-size', '11px')
        .style('pointer-events', 'none')
        .style("font-family", "Graphik Medium")
        .style('font-weight', 'bold')
        .text(d3.select(this).data()[0].FieldName)
      textSvg.append("tspan")
        .attr('x', 7)
        .attr('dy', 15)
        .style('pointer-events', 'none')
        .style('fill', d3.select(this).style('fill'))
        .html('&#x25cf') 
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style('font-size', '11px')
        .style("font-family", "Graphik Medium")
        .style('font-weight', 'bold')
        .text(Object.keys(d)[1] + ": ")
        .style('font-weight', 'bold')
      textSvg.append("tspan")
        .attr('dx', 0)
        .style('pointer-events', 'none')
        .style("font-family", "Graphik Medium")
        .style('font-weight', 'bold')
        .text(d3.format(',')(d3.select(this).data()[0].Ticket_Count) + ' (' + d3.select(this).data()[0].Percentage + '%)');
    })
      .on("mousemove", function (d, i) {
        d3.select(this).style('fill', function (d) {
          if (lineData.indexOf(d) >= 0) {
            return colors[lineData.indexOf(d) % colors.length]
          }
          else { return "#A260B7" }
        });
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];
        var y = mousePosition[1];
        var text: any;
        text = d3.select(this.closest('svg')).select('.tooltip text');
        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d, i) {
        d3.select(this).style('fill', function (d) {
          if (lineData.indexOf(d) >= 0) {
            return colors[lineData.indexOf(d) % colors.length]
          }
          else { return "#A260B7" }
        });
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)
          .style("opacity", 1);
      })
      .on('click', (d, i) => {
        let z = 0;
        if (this.currentPage > 1 && i >= 0) {
          z = i + this.barnumber
        } else { z = i; }
        this.dataQualityService.GetDataValidityDetails(d, i);                
      });
    chart
      .append('g')
      .selectAll()
      .data(this.viewData)
      .enter()
      .append('text')
      .attr('y', function (s) { return yScale(s.FieldName) + (yScale.bandwidth() / 2) + 2; })
      .attr("x", width + 5)
      .attr('height', barWidth)
      .attr('width', width)
      .attr("font-size", "8px")
      .style("fill", "black")
      .attr("font-family", "Graphik SemiBold")
      .text(d => {
        return that.CleanNumber(d.Percentage);
      })

    //Y Axis legend
    svg.append('text')
      .attr('x', -(height / 2))      
      .attr('y', 10)
      .attr("dy", "1em")
      .attr("font-family", "Graphik Regular")
      .attr('transform', 'rotate(-90)')
      .style('fill', '#015b63')
      .style('font-size', '12px')
      .style('font-weight', 'bold')
      .attr('text-anchor', 'middle')
      .text(this.XAxis + "(%)");

    //Pagination
    svg.append("path")
      .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
      .attr('transform', "translate(" + (margin.left - 15) + ", " + 25 + ") rotate(180)")
      .attr('class', 'leftTriangle')
      .attr('fill', '#000')
      .attr('stroke', '#000')
      .attr('stroke-width', 2)
      .attr("opacity", 0.7)
      .attr('cursor', 'pointer')
      .on('click', function (d) {
        if (that.currentPage != 1) {
          that.currentPage--;
          that.prevPage();
        }
      })
    svg.append("path")
      .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
      .attr('transform', "translate(" + (margin.left - 15) + ", " + (svgHeight - margin.bottom + 5) + ") rotate(180)")
      .attr('class', 'rightTriangle')
      .attr('fill', '#000')
      .attr('stroke', '#000')
      .attr('stroke-width', 2)
      .attr("opacity", 0.7)
      .style('cursor', 'pointer')
      .on('click', function (d) {
        if (that.currentPage < that.totalPage) {
          that.currentPage++;
          that.nextPage();
        }
      })

    if (that.currentPage == 1) {
      svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
    }
    if (that.currentPage == that.totalPage) {
      svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
    }
  }

  /*generic way */
  nextPage() {
    this.Load100PercBarChart(this.chartData, this.barChartContainerName);
  }

  prevPage() {
    this.Load100PercBarChart(this.chartData, this.barChartContainerName);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.Load100PercBarChart(this.chartData, this.barChartContainerName);
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  CleanNumber(str) {
    if (str != 0)
      str = str.toFixed(2);
    if (str >= 1)
      str = d3.format("~s")(str);
    else
      str = str;
    if (!this.isNumeric(str)) {
      let lastLetter = str.substring(str.length - 1);
      str = str.substring(0, str.length - 1);
      if (str.indexOf('.'))
        str = parseFloat(str).toFixed(1).toString() + lastLetter;
    }
    return str;
  }

  LoadMLPieChartsDQT(chartContainer, chartdata) {
    d3.select(chartContainer).html("");
    if (chartdata != null && Object.keys(chartdata[0]).length > 0) {
      this.drawGraph(chartdata[0], 3, chartContainer);
    }
    else {
      const NoData = [
        [{
          "label": "No Severity/Priority",
          "value": 0,
          "pertvalue": 0
        }]];
      this.drawGraph(NoData, 0, chartContainer);
    }
  }

  endAngleFn(d) {
    return d.value / 100 * Math.PI * 2;
  }

  drawGraph(categoryData, Totalcount, chartContainer) {
    var data = [];
    var count = 0;
    
    if (this.categoryId == 0) {
      for (var key in categoryData) {
        var data2 = [];
        var x;
        if (key.toLowerCase().includes('blank')) {         
          x = { "label": "No Severity", "value": 0, "pertvalue": 0 }
          data2.push(x);
          data.push(data2);
        }
        else {
          x = { "label": key, "value": categoryData[key], "pertvalue": categoryData[key] }
          data2.push(x);
          data.push(data2);
        }
        count++;
      }
    }
    else {
      if (Totalcount != 0) {
        for (var key in categoryData) {
          var data2 = [];
          var x;
          if (key.toLowerCase().includes('blank')) {
            x = { "label": "No Severity", "value": 0, "pertvalue": 0 }
            data2.push(x);
            data.push(data2);
          }
          else {
            x = { "label": key, "value": categoryData[key], "pertvalue": ((categoryData[key] * 100) / Totalcount).toFixed(2) }
            data2.push(x);
            data.push(data2);
          }
          count++;
        }
      }
      else {
        count = 1;
        data = categoryData;
      }
    }

    let containerIdwithoutHash = chartContainer.split('#')[1];
    const container = document.getElementById(containerIdwithoutHash);
    
    var svgWidth = container.clientWidth;
    var svgHeight = 300;
    var margin = { top: 20, right: 30, bottom: 50, left: 90 };
    var width = svgWidth - margin.left - margin.right;
    var height = svgHeight - margin.top - margin.bottom;

    var cwidth = 55;
    var cgap = 5;
    var color;

    if (Totalcount == 0)
      color = ["#e0ebeb"];
    else
      color = ["#E370B3", "#6DDBDC", "#267DB3", "#A35CB6", "#ff9966", "#00ff00", '#cc9900'];

    // append the svg object to the div called donut_container'
    const svg = d3.select(chartContainer)
      .append("svg")
      .classed("resizableSVG", true)
      .attr('xmlns', "http://www.w3.org/2000/svg")
      .attr('viewBox', "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom) + "")
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('overflow', 'visible')
      .style('margin-left', margin.left)
      .style('margin-right', margin.right);


    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.    
    const donut_chart = svg.append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / .8 + ")")
      .attr("class", "slices labels lines circles");

    const legendHead = svg.append('g')
      .attr("transform", "translate(" + width / 2 + ",0)")
      .attr("class", "legendgroup");

    // Compute the position of each group on the pie:
    const pie = d3.pie()
      .value(d => d.pertvalue)
    //.sort(d => d.pertvalue);
    let that = this;
    data.forEach((item, index) => {
      var backgroundArc = d3.arc()
        .innerRadius(cgap + cwidth * (index + 3))
        .outerRadius(cwidth * (index + 4))
        .startAngle(0)
        .endAngle(Math.PI * 2);

      var mainArc = d3.arc()
        .innerRadius(cgap + cwidth * (index + 3))
        .outerRadius(cwidth * (index + 4))
        .cornerRadius(cwidth / 1.5)
        .startAngle(0)
        .endAngle(d => this.endAngleFn(d));

      var outerArc = d3.arc()
        .innerRadius(cwidth * (index + 1) - 10)
        .outerRadius(cwidth * (index + 1) - 10);

      let charts = donut_chart
        .selectAll('path_' + index)
        .data(pie(item))
        .enter();

      charts.append("path")
        .attr("d", backgroundArc)
        .attr("fill", "#EBEFF4")

      charts.append("path")
        .attr("d", mainArc)
        .attr("fill", color[index])
        .on('mouseover', function (d, i) {
          d3.select(this).transition()
            .duration('50')
            .style('cursor', 'pointer')
            .attr('opacity', '.50')

          var tooltip = d3.select(container).select("svg")
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "tooltip")
            .style("opacity", 1)
          tooltip.append("rect")
            .attr("width", (d.data.label.length) * 2.5 + 160)
            .attr('height', 35)
            .style('text-align', 'center')
            .style('fill', '#FFFFFF')
            .style('pointer-events', 'none')
            .style('stroke', '#296986')
            .style('stroke-width', 4)
            .style('fill-opacity', 0.8);

          var textSvg = tooltip.append("text")
            .attr('x', 10)
            .attr('y', 22)
            .style('pointer-events', 'none')
            .style('fill', '#333333')
            .style('font-size', '18px')
            .style('color', '#333333');

          textSvg.append("tspan")
            .style('font-size', '17px')
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text(d.data.label + " - " + d.data.pertvalue + "%")
        })
        .on('mouseout', function () {
          d3.select(this).transition()
            .duration('50')
            .attr('opacity', '1')
          d3.select(container).select("svg").select('.tooltip').style('display', 'none');
          d3.select(container).select("svg").select(".tooltip").remove();
        })

      var newRadius = Math.min(width, height) / 2;
       var newOuterArc = d3.arc()
      .outerRadius(newRadius * 0.9)
      .innerRadius(newRadius * 0.9);
      svg.append("g")
      .attr("class", "labels");
      var label = svg.select('.labels').selectAll('text')
      .data(pie(data))
      .enter().append('text')
      //.attr('dy', '.35em')
      .attr('x', -34)
      .attr('y', 0)
      .style('font-size', '30px')
      .html(function (d) {
        return `${(d.data[0].pertvalue + '%')}`;
      });
    });    
  }
}
